import * as yup from "yup";

export function ValidateReferencesManual() {
    return yup.object().shape({
        movement_date: yup.string().required("Data do movimento é obrigatória"),
        operation_nature_id: yup.string().required("Natureza Operação é obrigatória"),
        justify: yup.string().required("Justificativa é obrigatória"),
    });
}
